// ./client/src/utilities/validations/validateCircuit.js

// ============================================================================
// Infer pin dataType/direction/protocol from pin name when no rule exists
// ============================================================================
function inferPinTypeFromName(pinName) {
  const name = pinName.toUpperCase();
  
  // ============================================================================
  // POWER & GROUND
  // ============================================================================
  
  // Power pins
  if (name.includes('VCC') || name.includes('VDD') || name.includes('PWR') || 
      name.includes('POWER') || name === '3V3' || name === '3.3V' || 
      name === '5V' || name === 'V+' || name === 'POSITIVE' || name === 'POS' || 
      name === 'VIN' || name === '12V') {
    return { dataType: 'power' };
  }
  
  // Ground pins
  if (name.includes('GND') || name.includes('GROUND') || name.includes('VSS') || 
      name.includes('CATHOD') || name === 'V-' || name === 'COM' || name === 'NEGATIVE' || name === 'NEG') {
    return { dataType: 'ground'};
  }

  // ============================================================================
  // COMMUNICATION PROTOCOLS (Hardware)
  // ============================================================================
  
  // I2C pins
  if (name === 'SDA' || name === 'SCL' || name.includes('I2C_SDA') || name.includes('I2C_SCL')) {
    return { dataType: 'signal', protocol: 'I2C' };
  }
  
  // SPI pins
  if (name === 'MOSI' || name === 'SDI') {
    return { dataType: 'signal', protocol: 'SPI' };
  }
  if (name === 'MISO' || name === 'SDO') {
    return { dataType: 'signal', protocol: 'SPI' };
  }
  if (name === 'SCK' || name === 'SCLK' || name === 'CLK') {
    return { dataType: 'signal', protocol: 'SPI' };
  }
  if (name === 'CS' || name === 'SS' || name === 'NSS' || name === 'CE') {
    return { dataType: 'signal', protocol: 'SPI' };
  }
  
  // UART pins
  if (name === 'TX' || name === 'TXD' || name === 'UART_TX') {
    return { dataType: 'signal', protocol: 'UART' };
  }
  if (name === 'RX' || name === 'RXD' || name === 'UART_RX') {
    return { dataType: 'signal', protocol: 'UART' };
  }

  // USB pins
  if (name === 'USB_DP' || name === 'D+' || name === 'USB_DM' || name === 'D-') {
    return { dataType: 'signal', protocol: 'USB' };
  }

  // ============================================================================
  // COMMUNICATION PROTOCOLS (Software - Bridge to Cloud)
  // ============================================================================
  
  // MQTT
  if (name === 'DEVICE_OUT' || name === 'CLOUD_IN') {
    return { dataType: 'protocol_data', protocol: 'MQTT' };
  }
  
  // HTTP
  if (name === 'REQUEST_OUT') {
    return { dataType: 'protocol_data', protocol: 'HTTP' };
  }
  if (name === 'RESPONSE_IN') {
    return { dataType: 'protocol_data', protocol: 'HTTP' };
  }
  
  // WebSocket
  if (name === 'SEND') {
    return { dataType: 'protocol_data', protocol: 'WebSocket' };
  }
  if (name === 'RECEIVE') {
    return { dataType: 'protocol_data', protocol: 'WebSocket' };
  }
  
  // AMQP
  if (name === 'PUBLISH') {
    return { dataType: 'protocol_data', protocol: 'AMQP' };
  }
  if (name === 'SUBSCRIBE') {
    return { dataType: 'protocol_data', protocol: 'AMQP' };
  }
  
  // Modbus TCP
  if (name === 'REQUEST') {
    return { dataType: 'protocol_data', protocol: 'Modbus' };
  }
  if (name === 'RESPONSE') {
    return { dataType: 'protocol_data', protocol: 'Modbus' };
  }
  
  // OPC UA
  if (name === 'READ' || name === 'WRITE') {
    return { dataType: 'protocol_data', protocol: 'OPC_UA' };
  }

  // ============================================================================
  // CLOUD SERVICE PINS (Azure)
  // ============================================================================
  
  // Azure IoT Hub
  if (name === 'TELEMETRY_IN') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  if (name === 'COMMAND_OUT') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  if (name === 'TWIN_UPDATE') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  
  // Device Twin
  if (name === 'REPORTED_IN') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  if (name === 'DESIRED_OUT') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  if (name === 'TAGS') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  
  // Stream Analytics / Event Hub
  if (name === 'DATA_IN') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  if (name === 'DATA_OUT') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  if (name === 'EVENTS_OUT') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  if (name === 'EVENTS_IN') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  
  // Storage
  if (name === 'WRITE_IN') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  if (name === 'READ_OUT') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }
  
  // Visualization
  if (name === 'DASHBOARD_IN') {
    return { dataType: 'cloud_data', protocol: 'CLOUD' };
  }

  // ============================================================================
  // SENSOR & ACTUATOR PINS
  // ============================================================================
  
  // Servo/PWM/Control
  if (name === 'SIGNAL' || name === 'PWM' || name === 'CONTROL') {
    return { dataType: 'signal', protocol: 'PWM' };
  }
  
  // Ultrasonic sensor
  if (name === 'TRIG') {
    return { dataType: 'signal', protocol: 'TRIGGER' };
  }
  if (name === 'ECHO') {
    return { dataType: 'signal', protocol: 'ECHO' };
  }
  
  // Motor control
  if (name === 'IN1' || name === 'IN2') {
    return { dataType: 'signal' };
  }
  
  // Status indicator
  if (name === 'STATUS') {
    return { dataType: 'signal' };
  }

  // ============================================================================
  // GENERIC DATA PINS
  // ============================================================================
  
  // Reset/Control pins
  if (name === 'RST' || name === 'RESET' || name === 'EN' || name === 'ENABLE') {
    return { dataType: 'signal' };
  }
  
  // Data pins (bidirectional by default)
  if (name === 'DATA') {
    return { dataType: 'signal'};
  }
  
  // Output pins
  if (name === 'OUT' || name === 'OUTPUT' || name === 'DOUT' || name === 'DO' || name === 'AOUT') {
    return { dataType: 'signal' };
  }
  
  // Input pins
  if (name === 'IN' || name === 'INPUT' || name === 'DIN' || name === 'DI') {
    return { dataType: 'signal' };
  }
  
  // GPIO pins - can be configured for different protocols
  if (name.includes('GPIO') || name.includes('IO') || /^D\d+$/.test(name) || 
      /^A\d+$/.test(name) || /^PIN/.test(name)) {
    return { dataType: 'gpio' };  // ✅ New dataType for flexible GPIO
  }
  
  // Analog pins
  if (name.includes('ANALOG') || name.includes('ADC') || name.includes('AIN')) {
    return { dataType: 'signal', protocol: 'ANALOG' };
  }
  
  // Default to signal
  return { dataType: 'signal'};
}

// ============================================================================
// BOARD PIN CAPABILITY VALIDATION (e.g. I2C_SDA, I2C_SCl, SPI_MOSI, ...)
// ============================================================================
function validateBoardPinCapability(boardComponent, boardPinName, sensorPinName) {
  // Only validate if it's a board
  if (boardComponent.category !== 'boards') {
    return { valid: true };
  }

  // Check if board has enhanced pinDetails
  if (!boardComponent.pinDetails || boardComponent.pinDetails.length === 0) {
    return { valid: true };
  }

  // Find the board pin
  const boardPin = boardComponent.pinDetails.find(p => p.pinName === boardPinName);
  
  if (!boardPin || !boardPin.capabilities || boardPin.capabilities.length === 0) {
    return { valid: true };
  }

  // Determine required capability based on sensor pin name
  const sensorPinUpper = sensorPinName.toUpperCase();
  let requiredCapability = null;
  let capabilityName = '';

  // I2C pins
  if (sensorPinUpper === 'SDA' || sensorPinUpper === 'I2C_SDA') {
    requiredCapability = ['i2c', 'i2c_sda', 'i2c_sda_default'];
    capabilityName = 'I2C SDA';
  } 
  else if (sensorPinUpper === 'SCL' || sensorPinUpper === 'I2C_SCL') {
    requiredCapability = ['i2c', 'i2c_scl', 'i2c_scl_default'];
    capabilityName = 'I2C SCL';
  }
  // SPI pins
  else if (sensorPinUpper === 'MOSI' || sensorPinUpper === 'SDI' || sensorPinUpper === 'DIN') {
    requiredCapability = ['spi', 'spi_mosi', 'spi_mosi_default'];
    capabilityName = 'SPI MOSI';
  } 
  else if (sensorPinUpper === 'MISO' || sensorPinUpper === 'SDO' || sensorPinUpper === 'DOUT') {
    requiredCapability = ['spi', 'spi_miso', 'spi_miso_default'];
    capabilityName = 'SPI MISO';
  } 
  else if (sensorPinUpper === 'SCK' || sensorPinUpper === 'SCLK' || sensorPinUpper === 'CLK') {
    requiredCapability = ['spi', 'spi_sck', 'spi_sck_default'];
    capabilityName = 'SPI SCK';
  } 
  else if (sensorPinUpper === 'CS' || sensorPinUpper === 'SS' || sensorPinUpper === 'NSS') {
    requiredCapability = ['spi', 'spi_cs', 'spi_cs_default'];
    capabilityName = 'SPI CS';
  }
  // UART pins
  else if (sensorPinUpper === 'TX' || sensorPinUpper === 'TXD' || sensorPinUpper === 'UART_TX') {
    requiredCapability = ['uart', 'uart_tx', 'uart_tx_default'];
    capabilityName = 'UART TX';
  } 
  else if (sensorPinUpper === 'RX' || sensorPinUpper === 'RXD' || sensorPinUpper === 'UART_RX') {
    requiredCapability = ['uart', 'uart_rx', 'uart_rx_default'];
    capabilityName = 'UART RX';
  }
  // Analog pins
  else if (sensorPinUpper.includes('AOUT') || sensorPinUpper.includes('ANALOG') || sensorPinUpper === 'AO') {
    requiredCapability = ['analog', 'adc1', 'adc2'];
    capabilityName = 'Analog input (ADC)';
  }
  // PWM/Signal pins
  else if (sensorPinUpper === 'SIGNAL' || sensorPinUpper === 'PWM') {
    requiredCapability = ['pwm', 'digital'];
    capabilityName = 'PWM';
  }
  // Generic data pins
  else if (sensorPinUpper === 'DATA' || sensorPinUpper === 'DOUT' || sensorPinUpper === 'OUT') {
    requiredCapability = ['digital'];
    capabilityName = 'Digital I/O';
  }

  // If no specific capability required, allow connection
  if (!requiredCapability) {
    return { valid: true };
  }

  // ✅ NOW check if board pin has the required capability (AFTER determining what's required)
  const hasCapability = requiredCapability.some(cap => 
    boardPin.capabilities.includes(cap)
  );

  if (!hasCapability) {
    return {
      valid: false,
      severity: 'error',
      message: `${boardPinName} does not support ${capabilityName}`,
      warning: `Pin capabilities: ${boardPin.capabilities.join(', ')}`
    };
  }

  // ✅ Special handling for I2C default pins
  if (sensorPinUpper === 'SDA' || sensorPinUpper === 'I2C_SDA') {
    const isDefaultPin = boardPin.capabilities.includes('i2c_sda_default');
    console.log('🔍 I2C SDA Check:', {
    boardPin: boardPinName,
    capabilities: boardPin.capabilities,
    isDefaultPin: isDefaultPin,
    sensorPin: sensorPinName
  });
    if (!isDefaultPin) {
      return {
        valid: true,
        severity: 'warning',
        message: `${boardPinName} can be used for I2C but GPIO21 is the default SDA pin`,
        warning: 'Using non-default I2C pins requires Wire.begin(SDA, SCL) in code'
      };
    }
  }
  
  if (sensorPinUpper === 'SCL' || sensorPinUpper === 'I2C_SCL') {
    const isDefaultPin = boardPin.capabilities.includes('i2c_scl_default');
    if (!isDefaultPin) {
      return {
        valid: true,
        severity: 'warning',
        message: `${boardPinName} can be used for I2C but GPIO22 is the default SCL pin`,
        warning: 'Using non-default I2C pins requires Wire.begin(SDA, SCL) in code'
      };
    }
  }

  // Check for ADC2 warning
  if (requiredCapability.includes('analog') && boardPin.capabilities.includes('adc2')) {
    return {
      valid: true,
      severity: 'warning',
      message: `${boardPinName} is ADC2 - unavailable when WiFi is active`,
      warning: `Consider using ADC1 pins instead for reliable analog readings with WiFi`
    };
  }

  // Check for other warnings
  if (boardPin.warnings && boardPin.warnings.length > 0) {
    return {
      valid: true,
      severity: 'warning',
      message: `${boardPinName}: ${boardPin.warnings[0]}`,
      warning: boardPin.warnings.join('; ')
    };
  }

  return { valid: true };
}

// ============================================================================
// POWER CONNECTION VALIDATION
// ============================================================================
function isVoltageCompatible(required, supplied) {
  // For adjustable/selectable power supplies, assume user will set correctly
  if (supplied.includes('selectable') || supplied.includes('adjustable')) {
    return true;
  }
  
  // Simple check: if voltage strings contain overlapping numbers, allow it
  const reqNums = required.match(/\d+\.?\d*/g)?.map(parseFloat) || [];
  const supNums = supplied.match(/\d+\.?\d*/g)?.map(parseFloat) || [];
  
  if (reqNums.length === 0 || supNums.length === 0) return true;
  
  // Check if any supplied voltage is within ±10% of any required voltage
  return supNums.some(sup => 
    reqNums.some(req => sup >= req * 0.9 && sup <= req * 1.1)
  );
}

function parseCurrentValue(currentStr) {
  if (!currentStr) return null;
  
  // ✅ NEW: Handle range format "1A - 5A" or "Up to 2A"
  if (currentStr.toLowerCase().includes('up to')) {
    const match = currentStr.match(/(\d+\.?\d*)\s*(mA|A)/i);
    if (!match) return null;
    let current = parseFloat(match[1]);
    if (match[2].toLowerCase() === 'ma') {
      current = current / 1000;
    }
    return current;
  }
  
  // ✅ Handle range: "1A - 5A" → extract max value (5A)
  const rangeMatch = currentStr.match(/(\d+\.?\d*)\s*(mA|A)?\s*-\s*(\d+\.?\d*)\s*(mA|A)/i);
  if (rangeMatch) {
    // Extract the MAX value from range (match[3])
    let current = parseFloat(rangeMatch[3]);
    const unit = rangeMatch[4] || rangeMatch[2]; // Use second unit, fallback to first
    if (unit && unit.toLowerCase() === 'ma') {
      current = current / 1000;
    }
    return current;
  }
  
  // ✅ Handle single value: "2A" or "600mA"
  const singleMatch = currentStr.match(/(\d+\.?\d*)\s*(mA|A)/i);
  if (singleMatch) {
    let current = parseFloat(singleMatch[1]);
    if (singleMatch[2].toLowerCase() === 'ma') {
      current = current / 1000;
    }
    return current;
  }
  
  return null;
}

function validatePowerConnection(fromComponent, fromPinName, toComponent, toPinName) {

    console.log('🔍 RAW PARAMS:', {
    fromComponent: fromComponent,
    fromComponentType: typeof fromComponent,
    fromComponentKeys: Object.keys(fromComponent || {}),
    toComponent: toComponent,
    toComponentType: typeof toComponent
  });
  
  const fromSpecs = fromComponent.specifications;
  const toSpecs = toComponent.specifications;
  const fromPowerReqs = fromSpecs?.powerRequirements;
  const toPowerReqs = toSpecs?.powerRequirements;

  // Check if we're connecting to a component's power pin
  const powerPins = ['VCC', 'POSITIVE', 'V+', 'VIN', '5V', '3.3V'];
  const isPowerConnection = powerPins.includes(fromPinName) || powerPins.includes(toPinName);

  if (!isPowerConnection) {
    return { valid: true }; // Not a power connection, no validation needed
  }

  // Determine which component is receiving power based on component category
  let receivingComponent, receivingPinName, supplyingComponent, supplyingPinName;

  // Check which component is a power supplier (power supply or board)
  if (toComponent.category === 'power' || toComponent.category === 'boards') {
    // toComponent is supplying power
    receivingComponent = fromComponent;
    receivingPinName = fromPinName;
    supplyingComponent = toComponent;
    supplyingPinName = toPinName;
  } else if (fromComponent.category === 'power' || fromComponent.category === 'boards') {
    // fromComponent is supplying power
    receivingComponent = toComponent;
    receivingPinName = toPinName;
    supplyingComponent = fromComponent;
    supplyingPinName = fromPinName;
  } else {
    // Neither is a clear power source - both are components
    // In this case, assume the connection shouldn't happen
    return { 
      valid: false,
      severity: 'error',
      message: 'Power connections should involve a board or power supply',
      warning: 'Connect components to a microcontroller board or external power supply'
    };
  }

  const receivingPowerReqs = receivingComponent.specifications?.powerRequirements;

  console.log('🔍 Power Validation Debug:', {
    fromComponent: fromComponent.name,
    fromPin: fromPinName,
    toComponent: toComponent.name,
    toPin: toPinName,
    receivingComponent: receivingComponent.name,
    supplyingComponent: supplyingComponent.name,
    supplyingCategory: supplyingComponent.category,
    receivingPowerReqs: receivingPowerReqs,
    needsExternal: receivingPowerReqs?.needsExternalPower,
    canBePoweredFromBoard: receivingPowerReqs?.canBePoweredFromBoard
  });

  // Check if component needs external power but is being powered from board
  if (receivingPowerReqs?.needsExternalPower && !receivingPowerReqs.canBePoweredFromBoard) {
    if (supplyingComponent.category === 'boards') {
      return {
        valid: false,
        severity: 'error',
        message: `${receivingComponent.label || receivingComponent.name} requires external power supply`,
        warning: receivingPowerReqs.notes || 
                `This component draws ${receivingPowerReqs.peakCurrent} and cannot be powered from the microcontroller. Use a separate ${receivingPowerReqs.externalVoltage} power supply.`
      };
    }
  }

  // Validate voltage compatibility
  if (receivingPowerReqs?.externalVoltage && supplyingComponent.category === 'power') {
    const requiredVoltage = receivingPowerReqs.externalVoltage;
    const suppliedVoltage = supplyingComponent.specifications?.voltage;

    if (suppliedVoltage && !isVoltageCompatible(requiredVoltage, suppliedVoltage)) {
      return {
        valid: false,
        severity: 'warning',
        message: `Voltage mismatch: ${receivingComponent.label || receivingComponent.name} needs ${requiredVoltage}, supply provides ${suppliedVoltage}`,
        warning: 'Please verify voltage settings on adjustable power supply'
      };
    }
  }

  // Validate current capacity
  if (receivingPowerReqs?.peakCurrent && supplyingComponent.category === 'power') {
    const requiredCurrent = parseCurrentValue(receivingPowerReqs.peakCurrent);
    const suppliedCurrent = parseCurrentValue(supplyingComponent.specifications?.current);

    if (requiredCurrent && suppliedCurrent && requiredCurrent > suppliedCurrent) {
      return {
        valid: false,
        severity: 'error',
        message: `Insufficient current: ${receivingComponent.label || receivingComponent.name} needs ${receivingPowerReqs.peakCurrent}, supply provides ${supplyingComponent.specifications?.current}`,
        warning: 'Component may not function properly or damage power supply'
      };
    }
  }

  return { 
    valid: true,
    info: receivingPowerReqs ? `Power validated: ${receivingPowerReqs.externalVoltage} @ ${receivingPowerReqs.peakCurrent}` : null
  };
}

// ============================================================================
// PINS CONNECTION REQUIREMENTS VALIDATION
// ============================================================================
function getPinValidationRule(pinName) {
  // Pin validation rules lookup
  const rules = {
    VCC: {
      type: 'power',
      dataType: 'power',
      connectsTo: ['3.3V', '5V', 'POSITIVE'],
      direction: 'input'
    },
    '3.3V': {
      type: 'power',
      dataType: 'power',
      connectsTo: ['VCC', '3.3V', '5V', 'POSITIVE'],
      direction: 'bidirectional'
    },
    '5V': {
      type: 'power',
      dataType: 'power',
      connectsTo: ['VCC', '3.3V', '5V', 'POSITIVE'],
      direction: 'bidirectional'
    },
    POSITIVE: {
      type: 'power',
      dataType: 'power',
      connectsTo: ['VCC', '3.3V', '5V'],
      direction: 'output'
    },
    GND: {
      type: 'ground',
      dataType: 'ground',
      connectsTo: ['GND', 'NEGATIVE', 'CATHOD'],
      direction: 'bidirectional'
    },
    NEGATIVE: {
      type: 'ground',
      dataType: 'ground',
      connectsTo: ['GND', 'NEGATIVE'],
      direction: 'bidirectional'
    },
    CATHOD: {
      type: 'ground',
      dataType: 'ground',
      connectsTo: ['GND', 'NEGATIVE'],
      direction: 'bidirectional'
    },
    SDA: {
      type: 'I2C',
      dataType: 'protocol_data',
      connectsTo: ['SDA'],
      direction: 'bidirectional',
      protocol: 'I2C'
    },
    SCL: {
      type: 'I2C',
      dataType: 'protocol_data',
      connectsTo: ['SCL'],
      direction: 'bidirectional',
      protocol: 'I2C'
    },
    MOSI: {
      type: 'SPI',
      dataType: 'protocol_data',
      connectsTo: ['MOSI'],
      direction: 'output',
      protocol: 'SPI'
    },
    MISO: {
      type: 'SPI',
      dataType: 'protocol_data',
      connectsTo: ['MISO'],
      direction: 'input',
      protocol: 'SPI'
    },
    SCK: {
      type: 'SPI',
      dataType: 'protocol_data',
      connectsTo: ['SCK'],
      direction: 'output',
      protocol: 'SPI'
    },
    CS: {
      type: 'SPI',
      dataType: 'protocol_data',
      connectsTo: ['CS'],
      direction: 'output',
      protocol: 'SPI'
    },
    TX: {
      type: 'UART',
      dataType: 'protocol_data',
      connectsTo: ['RX'],
      direction: 'output',
      protocol: 'UART'
    },
    RX: {
      type: 'UART',
      dataType: 'protocol_data',
      connectsTo: ['TX'],
      direction: 'input',
      protocol: 'UART'
    },
    DATA: {
      type: 'signal',
      dataType: 'signal',
      connectsTo: ['DATA', 'SIGNAL', 'GPIO'],
      direction: 'bidirectional'
    },
    ANAODE: {
      type: 'signal',
      dataType: 'signal',
      connectsTo: ['GPIO'],
      direction: 'bidirectional'
    },
    RES: {
      type: 'signal',
      dataType: 'signal',
      connectsTo: ['GPIO'],
      direction: 'bidirectional'
    },
    DC: {
      type: 'signal',
      dataType: 'signal',
      connectsTo: ['GPIO'],
      direction: 'bidirectional'
    },
    SIGNAL: {
      type: 'signal',
      dataType: 'signal',
      connectsTo: ['DATA', 'SIGNAL', 'GPIO'],
      direction: 'bidirectional'
    },
    PWM: {
      type: 'PWM',
      dataType: 'signal',
      connectsTo: ['SIGNAL', 'GPIO'],
      direction: 'output'
    },
    ANALOG: {
      type: 'analog',
      dataType: 'analog',
      connectsTo: ['SIGNAL', 'GPIO'],
      direction: 'input'
    }
  };
  
  return rules[pinName] || null;
}

function getConnectionStyle(fromPinName, toPinName) {
  let fromRule = getPinValidationRule(fromPinName);  
  let toRule = getPinValidationRule(toPinName);
  
  // ✅ Infer from pin name if no rule exists
  if (!fromRule) {
    fromRule = inferPinTypeFromName(fromPinName);
  }
  if (!toRule) {
    toRule = inferPinTypeFromName(toPinName);
  }
  
  // Default styling
  let connectionType = 'signal';
  let color = '#000000'; // Black
  let strokeWidth = 3;
  let strokeStyle = 'solid';
  
  const fromDataType = fromRule.dataType;
  const toDataType = toRule.dataType;
  const fromProtocol = fromRule.protocol;
  const toProtocol = toRule.protocol;
  
  // ============================================================================
  // POWER & GROUND
  // ============================================================================
  if (fromDataType === 'power' || toDataType === 'power') {
    connectionType = 'power';
    color = '#EF4444'; // 🔴 Red for power
    strokeWidth = 4;
    strokeStyle = 'solid';
  } 
  else if (fromDataType === 'ground' || toDataType === 'ground') {
    connectionType = 'ground';
    color = '#000000'; // ⚫ Black for ground
    strokeWidth = 4;
    strokeStyle = 'solid';
  }
  
  // ============================================================================
  // HARDWARE PROTOCOLS
  // ============================================================================
  else if (fromProtocol === 'I2C' || toProtocol === 'I2C') {
    connectionType = 'i2c';
    color = '#F97316'; // 🟠 Orange for I2C
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromProtocol === 'UART' || toProtocol === 'UART') {
    connectionType = 'uart';
    color = '#A855F7'; // 🟣 Purple for UART
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromProtocol === 'SPI' || toProtocol === 'SPI') {
    connectionType = 'spi';
    color = '#06B6D4'; // 🔵 Cyan for SPI
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromProtocol === 'USB' || toProtocol === 'USB') {
    connectionType = 'usb';
    color = '#22D3EE'; // 💠 Bright Cyan for USB
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromProtocol === 'ANALOG' || toProtocol === 'ANALOG') {
    connectionType = 'analog';
    color = '#EC4899'; // 🩷 Pink for Analog
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromProtocol === 'PWM' || toProtocol === 'PWM') {
    connectionType = 'pwm';
    color = '#F59E0B'; // 🟡 Amber for PWM
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromProtocol === 'TRIGGER' || toProtocol === 'TRIGGER' || 
           fromProtocol === 'ECHO' || toProtocol === 'ECHO') {
    connectionType = 'ultrasonic';
    color = '#14B8A6'; // 🟢 Teal for Ultrasonic
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  
  // ============================================================================
  // SOFTWARE PROTOCOLS (Communication Bridge)
  // ============================================================================
  else if (fromDataType === 'protocol_data' || toDataType === 'protocol_data') {
    connectionType = 'protocol';
    
    // Determine specific protocol for color coding
    if (fromProtocol === 'MQTT' || toProtocol === 'MQTT') {
      color = '#9333EA'; // 🟣 Purple for MQTT
    } else if (fromProtocol === 'HTTP' || toProtocol === 'HTTP') {
      color = '#059669'; // 🟢 Green for HTTP
    } else if (fromProtocol === 'WebSocket' || toProtocol === 'WebSocket') {
      color = '#3B82F6'; // 🔵 Blue for WebSocket
    } else if (fromProtocol === 'AMQP' || toProtocol === 'AMQP') {
      color = '#DC2626'; // 🔴 Red for AMQP
    } else if (fromProtocol === 'Modbus' || toProtocol === 'Modbus') {
      color = '#EA580C'; // 🟠 Orange for Modbus
    } else if (fromProtocol === 'OPC_UA' || toProtocol === 'OPC_UA') {
      color = '#7C3AED'; // 🟣 Deep Purple for OPC UA
    } else if (fromProtocol === 'CoAP' || toProtocol === 'CoAP') {
      color = '#06B6D4'; // 🔵 Cyan for CoAP
    } else if (fromProtocol === 'gRPC' || toProtocol === 'gRPC') {
      color = '#2563EB'; // 🔵 Blue for gRPC
    } else {
      color = '#8B5CF6'; // 🟣 Default purple for protocols
    }
    
    strokeWidth = 3;
    strokeStyle = 'dashed'; // Dashed for software protocols
  }
  
  // ============================================================================
  // CLOUD DATA (Azure Services)
  // ============================================================================
  else if (fromDataType === 'cloud_data' || toDataType === 'cloud_data') {
    connectionType = 'cloud';
    color = '#0EA5E9'; // ☁️ Sky blue for cloud
    strokeWidth = 4;
    strokeStyle = 'dotted'; // Dotted for cloud connections
  }
  
  // ============================================================================
  // GENERIC DATA TYPES (Legacy - kept for backward compatibility)
  // ============================================================================
  else if (fromDataType === 'telemetry' || toDataType === 'telemetry') {
    connectionType = 'telemetry';
    color = '#3B82F6'; // Blue for telemetry data
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromDataType === 'command' || toDataType === 'command') {
    connectionType = 'command';
    color = '#8B5CF6'; // Purple for commands
    strokeWidth = 3;
    strokeStyle = 'dashed';
  }
  else if (fromDataType === 'stream' || toDataType === 'stream') {
    connectionType = 'stream';
    color = '#10B981'; // Green for data streams
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromDataType === 'state' || toDataType === 'state') {
    connectionType = 'state';
    color = '#F59E0B'; // Orange for state sync
    strokeWidth = 2;
    strokeStyle = 'dashed';
  }
  else if (fromDataType === 'status' || toDataType === 'status') {
    connectionType = 'status';
    color = '#6B7280'; // Gray for status
    strokeWidth = 2;
    strokeStyle = 'dashed';
  }
  else if (fromDataType === 'signal' || toDataType === 'signal') {
    connectionType = 'signal';
    color = '#059669'; // Teal for digital signals
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromDataType === 'blob' || fromDataType === 'dataset' || 
          toDataType === 'blob' || toDataType === 'dataset') {
    connectionType = 'data';
    color = '#7C3AED'; // Deep purple for large data
    strokeWidth = 4;
    strokeStyle = 'solid';
  }
  else if (fromDataType === 'query' || fromDataType === 'datasource' ||
          toDataType === 'query' || toDataType === 'datasource') {
    connectionType = 'data';
    color = '#7C3AED'; // Deep purple for data queries
    strokeWidth = 3;
    strokeStyle = 'solid';
  }
  else if (fromDataType === 'visualization' || toDataType === 'visualization') {
    connectionType = 'visualization';
    color = '#EC4899'; // Pink for visualization
    strokeWidth = 3;
    strokeStyle = 'solid';
  }

  return { connectionType, color, strokeWidth, strokeStyle };
}

function canPinsConnect(fromPinName, toPinName) {
  let fromRule = getPinValidationRule(fromPinName);  // ✅ Add ()
  let toRule = getPinValidationRule(toPinName);      // ✅ Add ()
  
  // ✅ Infer from pin name if no rule exists
  if (!fromRule) {
    fromRule = inferPinTypeFromName(fromPinName);
  }
  if (!toRule) {
    toRule = inferPinTypeFromName(toPinName);
  }
  
  // ✅ Get connection styling
  const styling = getConnectionStyle(fromPinName, toPinName);
  
  // ── GPIO ↔ Hardware-protocol bridge ────────────────────────────────────────
  const hardwareProtocolPins = [
    'SDA', 'SCL',
    'MOSI', 'MISO', 'SCK', 'CS', 'SS',
    'TX', 'TXD', 'RX', 'RXD',
    'DATA', 'SIGNAL', 'DOUT', 'AOUT', 'RES', 'DC',
    'TRIG', 'ECHO', 'PWM', 'CONTROL',
    'IN1', 'IN2', 'IN3', 'IN4',
    'OUT', 'OUTPUT', 'DIN', 'DI'
  ];
  const gpioPattern = /^(GPIO|IO|D)\d+$/i;
  const fromIsGPIO = gpioPattern.test(fromPinName);
  const toIsGPIO   = gpioPattern.test(toPinName);
  const fromIsProtocol = hardwareProtocolPins.includes(fromPinName.toUpperCase());
  const toIsProtocol   = hardwareProtocolPins.includes(toPinName.toUpperCase());

  if ((fromIsGPIO && toIsProtocol) || (fromIsProtocol && toIsGPIO)) {
    return { valid: true, ...styling };
  }
  
  // ============================================================================
  // EXPLICIT CONNECTION RULES
  // ============================================================================
  
  // Check explicit connectsTo
  if (fromRule.connectsTo && fromRule.connectsTo.includes(toPinName)) {
    return { valid: true, ...styling };
  }
  
  // Check explicit connectsFrom
  if (toRule.connectsFrom && toRule.connectsFrom.includes(fromPinName)) {
    return { valid: true, ...styling };
  }
  
  // ============================================================================
  // DIRECTION & DATA TYPE COMPATIBILITY
  // ============================================================================
  
  // If BOTH have direction, check direction rules
  if (fromRule.direction && toRule.direction) {
    
    // Output → Input (same data type)
    if (fromRule.direction === 'output' && toRule.direction === 'input') {
      if (fromRule.dataType === toRule.dataType) {
        return { valid: true, ...styling };
      }
    }
    
    // Bidirectional compatibility
    if (fromRule.direction === 'bidirectional' || toRule.direction === 'bidirectional') {
      if (fromRule.dataType === toRule.dataType) {
        return { valid: true, ...styling };
      }
    }
    
    // Same direction = invalid (unless bidirectional)
    if (fromRule.direction === toRule.direction && fromRule.direction !== 'bidirectional') {
      return { 
        valid: false, 
        message: `Cannot connect ${fromRule.direction} to ${toRule.direction}`,
        ...styling
      };
    }
  }
  
  // If NO direction or only ONE has direction, allow based on dataType only
  if (fromRule.dataType === toRule.dataType) {
    return { valid: true, ...styling };
  }
  
  // ============================================================================
  // SPECIAL CASES
  // ============================================================================
  // ✅ GPIO pins can accept any signal or protocol (they're configurable)
  if (fromRule.dataType === 'gpio' || toRule.dataType === 'gpio') {
    // GPIO can connect to: signal, protocol_data, or other GPIO
    const allowedTypes = ['signal', 'protocol_data', 'gpio'];
    if (allowedTypes.includes(fromRule.dataType) && allowedTypes.includes(toRule.dataType)) {
      return { valid: true, ...styling };
    }
  }

  // ✅ Protocol data can connect to cloud data (bridge)
  if ((fromRule.dataType === 'protocol_data' && toRule.dataType === 'cloud_data') ||
      (fromRule.dataType === 'cloud_data' && toRule.dataType === 'protocol_data')) {
    return { valid: true, ...styling };
  }

  // ✅ Protocol data can connect to cloud data (bridge)
  if ((fromRule.dataType === 'protocol_data' && toRule.dataType === 'cloud_data') ||
      (fromRule.dataType === 'cloud_data' && toRule.dataType === 'protocol_data')) {
    return { valid: true, ...styling };
  }
  
  // ✅ Cloud data can connect to cloud data (Azure service interconnection)
  if (fromRule.dataType === 'cloud_data' && toRule.dataType === 'cloud_data') {
    return { valid: true, ...styling };
  }
  
  // ✅ Protocol data can connect to protocol data (protocol gateway)
  if (fromRule.dataType === 'protocol_data' && toRule.dataType === 'protocol_data') {
    return { valid: true, ...styling };
  }
  
  // ============================================================================
  // VALIDATION FAILED
  // ============================================================================
  
  let message = `Cannot connect ${fromPinName} to ${toPinName}`;
  
  if (fromRule.direction === toRule.direction && fromRule.direction !== 'bidirectional') {
    message = `Cannot connect ${fromRule.direction} to ${toRule.direction}`;
  } else if (fromRule.dataType !== toRule.dataType) {
    message = `Incompatible data types: ${fromRule.dataType} → ${toRule.dataType}`;
  }
  
  return { 
    valid: false, 
    message,
    ...styling
  };
}

function isConnectionAllowed(fromCategory, toCategory) {
  const rules = {
    
    // Hardware categories
    boards: ['sensors', 'actuators', 'displays', 'modules', 'components', 'power', 'security_device'],
    plc: ['sensors', 'actuators', 'displays', 'modules', 'components', 'power'],
    sensors: ['boards', 'plc'],
    actuators: ['boards', 'plc'],
    modules: ['boards', 'plc'],  // ✅ ADDED: modules can connect to communication (e.g., WiFi, BLE, LoRa)
    power: ['boards', 'sensors', 'actuators', 'displays', 'modules', 'components', 'security_device'],
    components: ['boards', 'components', 'plc'],  // ✅ ADDED: components can connect to each other (e.g., resistor to LED)
    security_device: ['boards', 'power'],

    // Communication protocols (bridge between hardware and cloud)
    communication: ['communication'],  // ✅ ADDED: communication can connect to communication (MQTT to HTTP gateway)
    edge_computing: ['boards', 'modules', 'communication', 'azure_iot', 'azure_analytics', 'azure_storage'],  // ✅ ADDED: modules, communication
    
    // Azure IoT categories
    azure_iot: ['azure_iot', 'azure_analytics', 'azure_storage', 'azure_visualization'],  // ✅ ADDED: azure_visualization
    azure_analytics: ['azure_iot', 'azure_analytics', 'azure_storage', 'azure_visualization'],  // ✅ ADDED: communication
    azure_storage: ['azure_iot', 'azure_analytics', 'azure_storage', 'azure_visualization', 'edge_computing'],  // ✅ ADDED: communication
    azure_visualization: ['azure_iot', 'azure_analytics', 'azure_storage', 'azure_visualization', 'edge_computing'],
    
    // AI layer — pipeline order enforced
    data: ['preprocessing', 'model'],
    preprocessing: ['data', 'model', 'training'],
    model: ['preprocessing', 'training', 'evaluation'],
    training: ['model', 'evaluation'],
    evaluation: ['training', 'output'],
    output: ['evaluation']
  };
  
  return rules[fromCategory]?.includes(toCategory);
};

function isWiFiEnabled(circuit) {
  if (!circuit || !circuit.components) return false;
  
  const board = circuit.components.find(c => c.category === 'boards');
  return board?.wirelessConfigs?.wifi?.enabled || false;
}

function requiresWiFi(componentName) {
  const wifiProtocols = ['MQTT', 'HTTP', 'WebSocket', 'CoAP', 'gRPC', 'AMQP'];
  return wifiProtocols.some(protocol => componentName?.toUpperCase().includes(protocol));
}

function getConnectedI2CDevices(circuit, excludeInstanceId = null) {
  if (!circuit || !circuit.components || !circuit.connections) return [];
  
  const board = circuit.components.find(c => c.category === 'boards');
  if (!board) return [];
  
  const connectedDevices = [];
  
  circuit.components.forEach(comp => {
    if (comp.instanceId === excludeInstanceId) return; // Skip current device
    if (comp.specs?.interface !== 'I2C') return; // Not I2C
    
    // Check if connected to board
    const isConnected = circuit.connections.some(conn =>
      (conn.from.componentInstanceId === comp.instanceId && conn.to.componentInstanceId === board.instanceId) ||
      (conn.to.componentInstanceId === comp.instanceId && conn.from.componentInstanceId === board.instanceId)
    );
    
    if (isConnected) {
      connectedDevices.push(comp);
    }
  });
  
  return connectedDevices;
}

function hasI2CPinConnected(circuit, componentInstanceId, pinName) {
  if (!circuit || !circuit.connections) return false;
  
  return circuit.connections.some(conn => {
    const fromMatch = conn.from.componentInstanceId === componentInstanceId && 
                     conn.from.pinName === pinName;
    const toMatch = conn.to.componentInstanceId === componentInstanceId && 
                   conn.to.pinName === pinName;
    return fromMatch || toMatch;
  });
}

export function validateConnectionRT(fromComponent, fromPinName, toComponent, toPinName, existingCircuit = null) {
  
  const fromPinDetail = fromComponent.pinDetails?.find(p => p.pinName === fromPinName);
  const toPinDetail = toComponent.pinDetails?.find(p => p.pinName === toPinName);
  
  // ============================================================================
  // 1. COMPONENT & PIN ENABLED VALIDATION (All component types)
  // ============================================================================
  const enabledErrors = [];

  // Check fromComponent enabled
  if (fromComponent.communicationConfigs) {
    // Only block if the FROM pin is a software/protocol pin AND all protocols are disabled
    const fromPinIsHardware = fromPinDetail && !fromPinDetail.isSoftwarePin && fromPinDetail.type !== 'software';
    if (!fromPinIsHardware) {
      const configKeys = Object.keys(fromComponent.communicationConfigs);
      if (configKeys.length > 0) {
        const allDisabled = configKeys.every(k =>
          fromComponent.communicationConfigs[k]?.enabled === false
        );
        if (allDisabled) {
          enabledErrors.push(`${fromComponent.label || fromComponent.componentName} is not enabled`);
        }
      }
    }
  }
  // Check toComponent enabled
  if (toComponent.communicationConfigs) {
    // Only block if the TO pin is a software/protocol pin AND all protocols are disabled
    const toPinIsHardware = toPinDetail && !toPinDetail.isSoftwarePin && toPinDetail.type !== 'software';
    if (!toPinIsHardware) {
      const configKeys = Object.keys(toComponent.communicationConfigs);
      if (configKeys.length > 0) {
        const allDisabled = configKeys.every(k =>
          toComponent.communicationConfigs[k]?.enabled === false
        );
        if (allDisabled) {
          enabledErrors.push(`${toComponent.label || toComponent.componentName} is not enabled`);
        }
      }
    }
  }

  // Check fromPin enabled
  if ((fromPinDetail?.isSoftwarePin === true || fromPinDetail?.type === 'software')
      && fromPinDetail.enabled === false) {
    enabledErrors.push(`Pin "${fromPinName}" on ${fromComponent.label || fromComponent.componentName} is not enabled`);
  }

  // Check toPin enabled
  if ((toPinDetail?.isSoftwarePin === true || toPinDetail?.type === 'software')
      && toPinDetail.enabled === false) {
    enabledErrors.push(`Pin "${toPinName}" on ${toComponent.label || toComponent.componentName} is not enabled`);
  }

  if (enabledErrors.length > 0) {
    return {
      valid: false,
      severity: 'error',
      message: enabledErrors.join(' | '),
      warning: `Fix all issues in the configuration panels before making connections`
    };
  }

  // ============================================================================
  // 1.5 COMPONENT CATEGORY CONNECTION VALIDATION
  // ============================================================================
  const isDriverConnection = 
    fromComponent.componentId?.includes('L298N') || 
    fromComponent.componentId?.includes('ULN2003') ||
    toComponent.componentId?.includes('L298N') || 
    toComponent.componentId?.includes('ULN2003');

  if (!isDriverConnection && !isConnectionAllowed(fromComponent.category, toComponent.category)) {
    return {
      valid: false,
      message: `Cannot connect ${fromComponent.category} to ${toComponent.category}`
    };
  }

  // ============================================================================
  // 1.6 AI PIPELINE ORDER VALIDATION
  // ============================================================================
  const aiCategories = ['data', 'preprocessing', 'model', 'training', 'evaluation', 'output'];
  const isAIConnection = 
    aiCategories.includes(fromComponent.category) || 
    aiCategories.includes(toComponent.category);

  if (isAIConnection) {
    const pipelineOrder = ['data', 'preprocessing', 'model', 'training', 'evaluation', 'output'];
    const fromIndex = pipelineOrder.indexOf(fromComponent.category);
    const toIndex = pipelineOrder.indexOf(toComponent.category);

    // Warn if skipping a stage
    if (fromIndex !== -1 && toIndex !== -1 && toIndex - fromIndex > 2) {
      return {
        valid: true,
        severity: 'warning',
        message: `Skipping pipeline stage: ${fromComponent.category} → ${toComponent.category}`,
        warning: `Consider adding intermediate stages for better pipeline clarity`
      };
    }

    // Error if going backwards in pipeline
    if (fromIndex !== -1 && toIndex !== -1 && toIndex < fromIndex) {
      return {
        valid: false,
        severity: 'error',
        message: `Invalid pipeline direction: ${fromComponent.category} → ${toComponent.category}`,
        warning: `AI pipeline must flow forward: data → preprocessing → model → training → evaluation → output`
      };
    }

    // Validate AI software pin direction
    // const fromPinDetail = fromComponent.pinDetails?.find(p => p.pinName === fromPinName);
    // const toPinDetail = toComponent.pinDetails?.find(p => p.pinName === toPinName);

    if (fromPinDetail?.isSoftwarePin && toPinDetail?.isSoftwarePin) {
      if (fromPinDetail.direction === 'input' && toPinDetail.direction === 'input') {
        return {
          valid: false,
          severity: 'error',
          message: `Cannot connect two input pins: ${fromPinName} → ${toPinName}`,
          warning: `Connect an OUTPUT pin to an INPUT pin`
        };
      }
      if (fromPinDetail.direction === 'output' && toPinDetail.direction === 'output') {
        return {
          valid: false,
          severity: 'error',
          message: `Cannot connect two output pins: ${fromPinName} → ${toPinName}`,
          warning: `Connect an OUTPUT pin to an INPUT pin`
        };
      }
    }

    // Check for duplicate AI connection
    if (existingCircuit) {
      const duplicate = existingCircuit.connections?.find(conn =>
        (conn.from.componentInstanceId === fromComponent.instanceId &&
        conn.from.pinName === fromPinName &&
        conn.to.componentInstanceId === toComponent.instanceId &&
        conn.to.pinName === toPinName) ||
        (conn.from.componentInstanceId === toComponent.instanceId &&
        conn.from.pinName === toPinName &&
        conn.to.componentInstanceId === fromComponent.instanceId &&
        conn.to.pinName === fromPinName)
      );
      if (duplicate) {
        return {
          valid: false,
          severity: 'warning',
          message: `This pipeline connection already exists`,
          connectionType: 'ai_data',
          color: '#8B5CF6',
          strokeWidth: 3,
          strokeStyle: 'dashed'
        };
      }
    }

    // AI connection valid — skip IoT-specific checks below
    return {
      valid: true,
      connectionType: 'ai_data',
      color: '#8B5CF6',
      strokeWidth: 3,
      strokeStyle: 'dashed',
      info: `AI pipeline connection: ${fromComponent.category} → ${toComponent.category}`
    };
  }

  // ============================================================================
  // 1.6 AGENTIC AI PIPELINE ORDER VALIDATION (Build Canvas + Graph Sub-Canvas)
  // ============================================================================
  const agenticCategories = [
    'foundation', 'chain', 'rag',
    'graph', 'graph_nodes', 'graph_edges',
    'tools', 'memory', 'output'
  ];

  const isAgenticConnection =
    agenticCategories.includes(fromComponent.category) ||
    agenticCategories.includes(toComponent.category);

  if (isAgenticConnection) {

    const buildCanvasOrder    = ['foundation', 'chain', 'rag', 'graph'];
    const graphSubCanvasOrder = ['graph_nodes', 'graph_edges'];

    const fromCat = fromComponent.category;
    const toCat   = toComponent.category;

    // ── Build Canvas direction ─────────────────────────────────────────────
    const fromBuildIdx = buildCanvasOrder.indexOf(fromCat);
    const toBuildIdx   = buildCanvasOrder.indexOf(toCat);

    if (fromBuildIdx !== -1 && toBuildIdx !== -1) {
      if (toBuildIdx < fromBuildIdx) {
        return {
          valid: false,
          severity: 'error',
          message: `Invalid Build Canvas direction: ${fromCat} → ${toCat}`,
          warning: `Build Canvas must flow forward: foundation → chain/rag → graph`
        };
      }
      if (toBuildIdx - fromBuildIdx > 2) {
        return {
          valid: true,
          severity: 'warning',
          message: `Skipping Build Canvas stage: ${fromCat} → ${toCat}`,
          warning: `Consider adding intermediate stages for better pipeline clarity`,
          connectionType: 'agent_data',
          color: '#8B5CF6',
          strokeWidth: 3,
          strokeStyle: 'dashed'
        };
      }
    }

    // ── Graph Sub-Canvas direction ─────────────────────────────────────────
    const fromGraphIdx = graphSubCanvasOrder.indexOf(fromCat);
    const toGraphIdx   = graphSubCanvasOrder.indexOf(toCat);

    if (fromGraphIdx !== -1 && toGraphIdx !== -1 && toGraphIdx < fromGraphIdx) {
      return {
        valid: false,
        severity: 'error',
        message: `Invalid Graph Sub-Canvas direction: ${fromCat} → ${toCat}`,
        warning: `Graph Sub-Canvas must flow: graph_nodes → graph_edges`
      };
    }

    // ── Pin direction check ────────────────────────────────────────────────
    if (fromPinDetail?.isSoftwarePin && toPinDetail?.isSoftwarePin) {
      if (fromPinDetail.direction === 'input' && toPinDetail.direction === 'input') {
        return {
          valid: false,
          severity: 'error',
          message: `Cannot connect two input pins: ${fromPinName} → ${toPinName}`,
          warning: `Connect an OUTPUT pin to an INPUT pin`
        };
      }
      if (fromPinDetail.direction === 'output' && toPinDetail.direction === 'output') {
        return {
          valid: false,
          severity: 'error',
          message: `Cannot connect two output pins: ${fromPinName} → ${toPinName}`,
          warning: `Connect an OUTPUT pin to an INPUT pin`
        };
      }
    }

    // ── Duplicate connection check ─────────────────────────────────────────
    if (existingCircuit) {
      const duplicate = existingCircuit.connections?.find(conn =>
        (conn.from.componentInstanceId === fromComponent.instanceId &&
         conn.from.pinName === fromPinName &&
         conn.to.componentInstanceId === toComponent.instanceId &&
         conn.to.pinName === toPinName) ||
        (conn.from.componentInstanceId === toComponent.instanceId &&
         conn.from.pinName === toPinName &&
         conn.to.componentInstanceId === fromComponent.instanceId &&
         conn.to.pinName === fromPinName)
      );
      if (duplicate) {
        return {
          valid: false,
          severity: 'warning',
          message: `This agentic pipeline connection already exists`,
          connectionType: 'agent_data',
          color: '#8B5CF6',
          strokeWidth: 3,
          strokeStyle: 'dashed'
        };
      }
    }

    // ── Determine wire type by category pair ──────────────────────────────
    let connectionType = 'agent_data';
    let color          = '#8B5CF6';   // default purple

    if (['graph_nodes', 'graph_edges'].includes(fromCat) ||
        ['graph_nodes', 'graph_edges'].includes(toCat)) {
      connectionType = 'state_flow';
      color          = '#7C3AED';   // deeper purple for state flow
    } else if (fromCat === 'rag' || toCat === 'rag') {
      connectionType = 'rag_context';
      color          = '#0F6E56';   // green for RAG context
    } else if (fromCat === 'tools' || toCat === 'tools') {
      connectionType = 'tool_call';
      color          = '#B45309';   // amber for tool calls
    } else if (fromCat === 'memory' || toCat === 'memory') {
      connectionType = 'memory_flow';
      color          = '#1D4ED8';   // blue for memory
    }

    return {
      valid: true,
      connectionType,
      color,
      strokeWidth: 3,
      strokeStyle: 'dashed',
      info: `Agentic pipeline connection: ${fromCat} → ${toCat}`
    };
  }

  // ============================================================================
  // 2. BASIC PIN VALIDATION
  // ============================================================================
  const pinValidation = canPinsConnect(fromPinName, toPinName);
  
  if (!pinValidation.valid) {
    return pinValidation;
  }

  // ============================================================================
  // 3. PROTOCOL/CLOUD CONNECTION VALIDATION
  // ============================================================================
  // const isProtocolConnection = 
  //   fromComponent.category === 'communication' || 
  //   toComponent.category === 'communication';
  
  // const isCloudConnection = 
  //   ['azure_iot', 'azure_analytics', 'azure_storage', 'azure_visualization'].includes(fromComponent.category) ||
  //   ['azure_iot', 'azure_analytics', 'azure_storage', 'azure_visualization'].includes(toComponent.category);

  // if (isProtocolConnection || isCloudConnection) {
  //   const pinValidation = canPinsConnect(fromPinName, toPinName);
    
  //   if (!pinValidation.valid) {
  //     return {
  //       ...pinValidation,
  //       valid: false,
  //       message: `Invalid protocol/cloud connection: ${pinValidation.message}`
  //     };
  //   }
    
  //   return {
  //     ...pinValidation,
  //     valid: true,
  //     info: `${fromComponent.category} to ${toComponent.category} connection established`
  //   };
  // }

  // ============================================================================
  // 3. PROTOCOL/CLOUD CONNECTION VALIDATION
  // ============================================================================
  const isProtocolConnection =
    fromComponent.category === 'communication' ||
    toComponent.category === 'communication';

  const isCloudConnection =
    ['azure_iot', 'azure_analytics', 'azure_storage', 'azure_visualization'].includes(fromComponent.category) ||
    ['azure_iot', 'azure_analytics', 'azure_storage', 'azure_visualization'].includes(toComponent.category);

  if (isProtocolConnection || isCloudConnection) {

    // ... component enabled checks from Issue 1 fix above ...

    // ✅ FIX: Check pin enabled BEFORE allowing the connection
    if (fromComponent.pinDetails) {
      const fromPinDetail = fromComponent.pinDetails.find(p => p.pinName === fromPinName);
      if (fromPinDetail?.isSoftwarePin === true && fromPinDetail.enabled === false) {
        return {
          valid: false,
          severity: 'error',
          message: `Pin "${fromPinName}" is not enabled`,
          warning: `Enable this pin in ${fromComponent.label || fromComponent.componentName} configuration panel`
        };
      }
    }

    if (toComponent.pinDetails) {
      const toPinDetail = toComponent.pinDetails.find(p => p.pinName === toPinName);
      if (toPinDetail?.isSoftwarePin === true && toPinDetail.enabled === false) {
        return {
          valid: false,
          severity: 'error',
          message: `Pin "${toPinName}" is not enabled`,
          warning: `Enable this pin in ${toComponent.label || toComponent.componentName} configuration panel`
        };
      }
    }

    // existing pin validation
    const pinValidation = canPinsConnect(fromPinName, toPinName);
    if (!pinValidation.valid) {
      return {
        ...pinValidation,
        valid: false,
        message: `Invalid protocol/cloud connection: ${pinValidation.message}`
      };
    }

    return {
      ...pinValidation,
      valid: true,
      info: `${fromComponent.category} to ${toComponent.category} connection established`
    };
  }

  // ============================================================================
  // 3.5. COMPONENT ENABLE VALIDATION (All components with communicationConfigs)
  // ============================================================================
  // if (fromComponent.communicationConfigs) {
  //   // Get the first (and typically only) config key
  //   const configKeys = Object.keys(fromComponent.communicationConfigs);
    
  //   if (configKeys.length > 0) {
  //     const protocolConfig = fromComponent.communicationConfigs[configKeys[0]];
      
  //     if (protocolConfig && protocolConfig.enabled === false) {
  //       return {
  //         valid: false,
  //         severity: 'error',
  //         message: `${fromComponent.label || fromComponent.componentName} is not enabled`,
  //         warning: `Enable this component in its configuration panel before making connections`
  //       };
  //     }
  //   }
  // }
  if (fromComponent.communicationConfigs && fromComponent.category !== 'plc') {
    const configKeys = Object.keys(fromComponent.communicationConfigs);
    if (configKeys.length > 0) {
      const protocolConfig = fromComponent.communicationConfigs[configKeys[0]];
      if (protocolConfig && protocolConfig.enabled === false) {
        return {
          valid: false,
          severity: 'error',
          message: `${fromComponent.label || fromComponent.componentName} is not enabled`,
          warning: `Enable this component in its configuration panel before making connections`
        };
      }
    }
  }
  
  // if (toComponent.communicationConfigs) {
  //   const configKeys = Object.keys(toComponent.communicationConfigs);
  //   if (configKeys.length > 0) {
  //     const protocolConfig = toComponent.communicationConfigs[configKeys[0]];
  //     if (protocolConfig && protocolConfig.enabled === false) {
  //       return {
  //         valid: false,
  //         severity: 'error',
  //         message: `${toComponent.label || toComponent.componentName} is not enabled`,
  //         warning: `Enable this component in its configuration panel before making connections`
  //       };
  //     }
  //   }
  // }
  if (toComponent.communicationConfigs && toComponent.category !== 'plc') {
    const configKeys = Object.keys(toComponent.communicationConfigs);
    if (configKeys.length > 0) {
      const protocolConfig = toComponent.communicationConfigs[configKeys[0]];
      if (protocolConfig && protocolConfig.enabled === false) {
        return {
          valid: false,
          severity: 'error',
          message: `${toComponent.label || toComponent.componentName} is not enabled`,
          warning: `Enable this component in its configuration panel before making connections`
        };
      }
    }
  }
  // ============================================================================
  // 4. SOFTWARE PIN ENABLED & CONFIGURED VALIDATION
  // ============================================================================
  if (fromComponent.pinDetails) {
    const fromPinDetail = fromComponent.pinDetails.find(p => p.pinName === fromPinName);
    
    if (fromPinDetail?.isSoftwarePin === true) {
      // Check if pin is enabled
      if (fromPinDetail.enabled === false) {
        return {
          valid: false,
          severity: 'error',
          message: `Pin "${fromPinName}" is not enabled`,
          warning: `Enable this pin in ${fromComponent.label || fromComponent.componentName} configuration panel`
        };
      }
      
      // Check if pin is configured (has required settings)
      if (fromPinDetail.validationRules && fromPinDetail.settings) {
        const missingSettings = [];
        
        Object.keys(fromPinDetail.validationRules).forEach(field => {
          const rule = fromPinDetail.validationRules[field];
          const value = fromPinDetail.settings[field];
          
          // Check required fields
          if (rule.required && (!value && value !== 0 && value !== false)) {
            missingSettings.push(field);
          }
        });
        
        if (missingSettings.length > 0) {
          return {
            valid: false,
            severity: 'error',
            message: `Pin "${fromPinName}" is not fully configured`,
            warning: `Configure these settings: ${missingSettings.join(', ')}`
          };
        }
      }
    }
  }

  if (toComponent.pinDetails) {
    const toPinDetail = toComponent.pinDetails.find(p => p.pinName === toPinName);
    
    if (toPinDetail?.isSoftwarePin === true) {
      // Check if pin is enabled
      if (toPinDetail.enabled === false) {
        return {
          valid: false,
          severity: 'error',
          message: `Pin "${toPinName}" is not enabled`,
          warning: `Enable this pin in ${toComponent.label || toComponent.componentName} configuration panel`
        };
      }
      
      // Check if pin is configured (has required settings)
      if (toPinDetail.validationRules && toPinDetail.settings) {
        const missingSettings = [];
        
        Object.keys(toPinDetail.validationRules).forEach(field => {
          const rule = toPinDetail.validationRules[field];
          const value = toPinDetail.settings[field];
          
          // Check required fields
          if (rule.required && (!value && value !== 0 && value !== false)) {
            missingSettings.push(field);
          }
        });
        
        if (missingSettings.length > 0) {
          return {
            valid: false,
            severity: 'error',
            message: `Pin "${toPinName}" is not fully configured`,
            warning: `Configure these settings: ${missingSettings.join(', ')}`
          };
        }
      }
    }
  }
  // ============================================================================
  // 5. POWER REQUIREMENTS VALIDATION
  // ============================================================================
  const powerValidation = validatePowerConnection(
    fromComponent, 
    fromPinName, 
    toComponent, 
    toPinName
  );

  if (!powerValidation.valid) {
    return {
      ...pinValidation,
      valid: false,
      message: powerValidation.message,
      warning: powerValidation.warning,
      severity: powerValidation.severity
    };
  }

  // ============================================================================
  // 6. GPIO OCCUPATION VALIDATION
  // ============================================================================
  // if (existingCircuit && (fromComponent.category === 'boards' || toComponent.category === 'boards')) {
  //   const boardComponent = fromComponent.category === 'boards' ? fromComponent : toComponent;
  //   const boardPin = fromComponent.category === 'boards' ? fromPinName : toPinName;
    
  //   if (boardPin.includes('GPIO')) {
  //     const existingConnection = existingCircuit.connections?.find(conn => 
  //       (conn.from.componentInstanceId === boardComponent.instanceId && conn.from.pinName === boardPin) ||
  //       (conn.to.componentInstanceId === boardComponent.instanceId && conn.to.pinName === boardPin)
  //     );
      
  //     if (existingConnection) {
  //       return {
  //         ...pinValidation,
  //         valid: false,
  //         severity: 'warning',
  //         message: `${boardPin} is already occupied`,
  //         warning: `Each GPIO pin can only be connected to one component at a time`
  //       };
  //     }
  //   }
  // }

  if (existingCircuit && (fromComponent.category === 'boards' || toComponent.category === 'boards')) {
    const boardComponent = fromComponent.category === 'boards' ? fromComponent : toComponent;
    const boardPin = fromComponent.category === 'boards' ? fromPinName : toPinName;
    const devicePinBeingConnected = fromComponent.category === 'boards' ? toPinName : fromPinName;

    if (boardPin.includes('GPIO')) {

      // ── Shared-bus exemption ────────────────────────────────────────────────
      // I2C SDA/SCL, SPI MOSI/MISO/SCK are shared buses — multiple devices may
      // legally connect to the same board pin.  Only CS (chip-select) is
      // exclusive on SPI.  Do NOT fire the "already occupied" error for these.
      const sharedBusPins = ['SDA', 'SCL', 'MOSI', 'MISO', 'SCK'];
      const isSharedBus = sharedBusPins.includes(devicePinBeingConnected.toUpperCase());

      if (!isSharedBus) {
        const existingConnection = existingCircuit.connections?.find(conn =>
          (conn.from.componentInstanceId === boardComponent.instanceId && conn.from.pinName === boardPin) ||
          (conn.to.componentInstanceId === boardComponent.instanceId && conn.to.pinName === boardPin)
        );

        if (existingConnection) {
          return {
            ...pinValidation,
            valid: false,
            severity: 'warning',
            message: `${boardPin} is already occupied`,
            warning: `Each GPIO pin can only be connected to one component at a time`
          };
        }
      }
    }
  }

  // ============================================================================
  // 7. BOARD PIN CAPABILITY VALIDATION
  // ============================================================================
  if (fromComponent.category === 'boards' || toComponent.category === 'boards') {
    
    let capabilityValidation = { valid: true };
    
    if (toComponent.category === 'boards') {
      capabilityValidation = validateBoardPinCapability(toComponent, toPinName, fromPinName);
    }
    
    if (capabilityValidation.valid && fromComponent.category === 'boards') {
      capabilityValidation = validateBoardPinCapability(fromComponent, fromPinName, toPinName);
    }

    if (!capabilityValidation.valid) {
      return {
        ...pinValidation,
        valid: false,
        message: capabilityValidation.message,
        warning: capabilityValidation.warning,
        severity: capabilityValidation.severity
      };
    }

    if (capabilityValidation.severity === 'warning') {
      return {
        ...pinValidation,
        valid: true,
        severity: 'warning',
        message: capabilityValidation.message,
        warning: capabilityValidation.warning,
        powerInfo: powerValidation.info
      };
    }
  }

  // ============================================================================
  // 8. PIN RESTRICTIONS ENFORCEMENT (Phase 2 - High Priority)
  // ============================================================================
  const boardComponent = fromComponent.category === 'boards' ? fromComponent : toComponent;
  const boardPinName = fromComponent.category === 'boards' ? fromPinName : toPinName;
  const deviceComponent = fromComponent.category === 'boards' ? toComponent : fromComponent;
  const boardPin = boardComponent.pinDetails?.find(p => p.pinName === boardPinName);
  

  if (fromComponent.category === 'boards' || toComponent.category === 'boards') {
    if (boardPin?.restrictions && boardPin.restrictions.length > 0) {
      // Check input_only restriction
      if (boardPin.restrictions.includes('input_only')) {
        if (deviceComponent.category === 'actuators') {
          return {
            ...pinValidation,
            valid: false,
            severity: 'error',
            message: `${boardPinName} is input-only and cannot drive actuators`,
            warning: `Use GPIO 0-33 for output devices. GPIO 34-39 are input-only.`
          };
        }
      }
      
      // Check strapping_pin restriction (warning only)
      if (boardPin.restrictions.includes('strapping_pin')) {
        return {
          ...pinValidation,
          valid: true,
          severity: 'warning',
          message: `${boardPinName} is a strapping pin - ensure proper boot voltage`,
          warning: boardPin.warnings?.join('; ') || 'This pin affects boot mode. Check component compatibility.'
        };
      }
    }
  }
  
  // ============================================================
  // STEP 8.5: SENSOR/MODULE PIN WARNINGS & RESTRICTIONS
  // ============================================================
  const devicePinName = fromComponent.category === 'boards' ? toPinName : fromPinName;
  const devicePin = deviceComponent.pinDetails?.find(p => p.pinName === devicePinName);

  if (devicePin) {
    // Check restrictions first (blocks connection)
    if (devicePin.restrictions?.length > 0) {
      
      // ✅ Check voltage-specific restrictions
      if (devicePin.restrictions.includes('3v3_only')) {
        // Check if connecting to 3.3V pin
        const is3v3Pin = boardPinName === '3.3V' || 
                        boardPinName === '3V3' || 
                        boardPinName?.includes('3.3') ||
                        boardPinName?.includes('3V3') ||
                        boardPin?.mode === '3.3V' ||
                        boardPin?.description?.toLowerCase().includes('3.3v');
        
        if (!is3v3Pin) {
          // Check if trying to connect to 5V (common mistake)
          const is5vPin = boardPinName === '5V' || 
                          boardPinName === 'VIN' || 
                          boardPinName?.includes('5V') ||
                          boardPin?.mode === '5V' ||
                          boardPin?.description?.toLowerCase().includes('5v');
          
          if (is5vPin) {
            return {
              ...pinValidation,
              valid: false,
              severity: 'error',
              message: `${deviceComponent.componentName} requires 3.3V - 5V will damage sensor`,
              warning: `This component only accepts 3.3V (maximum 3.6V). Connecting to 5V will permanently damage the sensor. Use ESP32's 3.3V pin instead.`
            };
          }
          
          // Other voltage (not 3.3V, not 5V)
          return {
            ...pinValidation,
            valid: false,
            severity: 'error',
            message: `${deviceComponent.componentName} requires 3.3V power`,
            warning: `Connect ${devicePinName} to ESP32's 3.3V pin.`
          };
        }
        // Connecting to 3.3V - allow without warning
      }
      
      // ✅ ADDED: Check 5V-only restrictions
      if (devicePin.restrictions.includes('5v_only')) {
        const is5vPin = boardPinName === '5V' || 
                        boardPinName === 'VIN' || 
                        boardPin?.mode === '5V' ||
                        boardPin?.description?.includes('5V');
        
        if (!is5vPin) {
          return {
            ...pinValidation,
            valid: false,
            severity: 'error',
            message: `${devicePinName} requires 5V power`,
            warning: `This component requires 5V. Connect VCC to ESP32's 5V pin, not 3.3V.`
          };
        }
      }
      
      // Only block if restriction is serious AND not voltage-related (already handled above)
      const blockingRestrictions = devicePin.restrictions.filter(r => 
        r !== 'sccb_pin' && // sccb_pin is a warning, not a blocker
        r !== '3v3_only' && // Already handled above
        r !== '5v_only'     // Already handled above
      );

      if (blockingRestrictions.length > 0) {
        return {
          ...pinValidation,
          valid: false,
          severity: 'error',
          message: `${devicePinName} has restrictions: ${blockingRestrictions.join(', ')}`,
          warning: `Check component documentation before connecting`
        };
      }

      // Non-blocking restrictions → show as warning (only for sccb_pin now)
      const warningRestrictions = devicePin.restrictions.filter(r => r === 'sccb_pin');
      if (warningRestrictions.length > 0) {
        return {
          ...pinValidation,
          valid: true,
          severity: 'warning',
          message: `${deviceComponent.componentName} (${devicePinName}): ${warningRestrictions.join(', ')}`,
          warning: devicePin.warnings?.join('; ') || `Pin has restrictions: ${warningRestrictions.join(', ')}`
        };
      }
    }

    // Check warnings (allows connection but notifies user)
    if (devicePin.warnings?.length > 0) {
      return {
        ...pinValidation,
        valid: true,
        severity: 'warning',
        message: `${deviceComponent.componentName} (${devicePinName}): ${devicePin.warnings[0]}`,
        warning: devicePin.warnings.join('; ')
      };
    }
  }
  // ============================================================================
  // 9. CROSS-COMPONENT DEPENDENCIES (Phase 2 - High Priority)
  // ============================================================================
  if (existingCircuit) {
    if (fromComponent.category === 'communication' || toComponent.category === 'communication') {
      const commComponent = fromComponent.category === 'communication' ? fromComponent : toComponent;
      
      if (requiresWiFi(commComponent.componentName) && !isWiFiEnabled(existingCircuit)) {
        const board = existingCircuit.components?.find(c => c.category === 'boards');
        return {
          ...pinValidation,
          valid: false,
          severity: 'error',
          message: `${commComponent.componentName} requires WiFi to be enabled`,
          warning: `Enable WiFi in ${board?.componentName || 'board'} configuration`
        };
      }
    }
  }

  // ============================================================================
  // 9.5 MOTOR DRIVER REQUIREMENTS VALIDATION
  // ============================================================================

  // Check if trying to connect motor directly to board
  if (fromComponent.category === 'boards' || toComponent.category === 'boards') {
    const boardComponent = fromComponent.category === 'boards' ? fromComponent : toComponent;
    const deviceComponent = fromComponent.category === 'boards' ? toComponent : fromComponent;
    
    // Check if device is a motor (not a motor driver)
    const isMotor = (deviceComponent.componentId?.includes('DC MOTOR') || 
                deviceComponent.componentId?.includes('STEPPER') ||
                deviceComponent.componentId?.includes('AC MOTOR') ||
                deviceComponent.componentName?.toLowerCase().includes('dc motor')) &&
                !deviceComponent.componentId?.includes('L298N') && 
                !deviceComponent.componentId?.includes('ULN2003') &&
                !deviceComponent.componentName?.includes('L298N') &&
                !deviceComponent.componentName?.includes('ULN2003');
    
    if (isMotor) {
      return {
        ...pinValidation,
        valid: false,
        severity: 'error',
        message: `${deviceComponent.componentName || deviceComponent.name} cannot be connected directly to board`,
        warning: `Motors require a driver (L298N for DC motors, ULN2003 for stepper motors). Connect motor to driver outputs, then driver inputs to board GPIO.`
      };
    }
  }

  // Check if trying to connect motor output to board GPIO
  // const fromPinDetail = fromComponent.pinDetails?.find(p => p.pinName === fromPinName);
  // const toPinDetail = toComponent.pinDetails?.find(p => p.pinName === toPinName);

  if (fromPinDetail?.restrictions?.includes('motor_only') && toComponent.category === 'boards') {
    return {
      ...pinValidation,
      valid: false,
      severity: 'error',
      message: `${fromPinName} is a motor output and cannot connect to board GPIO`,
      warning: `This pin outputs high current to drive motors. Connect it to a motor terminal, not to the microcontroller.`
    };
  }

  if (toPinDetail?.restrictions?.includes('motor_only') && fromComponent.category === 'boards') {
    return {
      ...pinValidation,
      valid: false,
      severity: 'error',
      message: `${toPinName} is a motor output and cannot connect to board GPIO`,
      warning: `This pin outputs high current to drive motors. Connect it to a motor terminal, not to the microcontroller.`
    };
  }

  // ============================================================================
  // Step 10: Protocol Completeness
  // ============================================================================
  if (existingCircuit && (fromComponent.category === 'boards' || toComponent.category === 'boards')) {
    const deviceComponent = fromComponent.category === 'boards' ? toComponent : fromComponent;
    
    if (fromPinName === 'SDA' || toPinName === 'SDA') {
      if (!hasI2CPinConnected(existingCircuit, deviceComponent.instanceId, 'SCL')) {
        return {
          ...pinValidation,
          valid: true,
          severity: 'warning',
          message: `I2C requires both SDA and SCL - don't forget to connect SCL`
        };
      }
    }
    
    if (fromPinName === 'SCL' || toPinName === 'SCL') {
      if (!hasI2CPinConnected(existingCircuit, deviceComponent.instanceId, 'SDA')) {
        return {
          ...pinValidation,
          valid: true,
          severity: 'warning',
          message: `I2C requires both SDA and SCL - don't forget to connect SDA`
        };
      }
    }
  }

  // ============================================================================
  // Step 11: I2C Address Conflicts
  // ============================================================================
  if (existingCircuit && deviceComponent.specs?.interface === 'I2C' && deviceComponent.specs?.i2cAddress) {
    const connectedI2CDevices = getConnectedI2CDevices(existingCircuit, deviceComponent.instanceId);
    
    const conflictDevice = connectedI2CDevices.find(comp => 
      comp.specs?.i2cAddress === deviceComponent.specs.i2cAddress
    );
    
    if (conflictDevice) {
      return {
        ...pinValidation,
        valid: false,
        severity: 'error',
        message: `I2C address conflict: 0x${deviceComponent.specs.i2cAddress.toString(16).toUpperCase()}`,
        warning: `${deviceComponent.componentName} and ${conflictDevice.componentName} both use the same address`
      };
    }
  }

  // ============================================================================
  // ALL VALIDATIONS PASSED
  // ============================================================================
  return {
    ...pinValidation,
    valid: true,
    powerInfo: powerValidation.info
  };
}


// ============================================================================
// COMPONENT CONFIGURATION VALIDATION (for modal use)
// ============================================================================

/**
 * Validate component configuration against validation rules
 * @param {Object} component - Component from library
 * @param {Object} config - Instance configuration
 * @returns {Object} - { valid, errors, warnings }
 */
export function validateComponentConfigRT(component, config) {
  const errors = [];
  const warnings = [];

  console.log('🔍 Frontend validation starting for:', component.componentName || component.name);
  console.log('🔍 Config:', JSON.stringify(config, null, 2));

  // Validate communication configs
  if (component.communicationConfigs && config.communicationConfigs) {
    Object.keys(config.communicationConfigs).forEach(protocol => {
      const protocolConfig = component.communicationConfigs[protocol];
      const instanceConfig = config.communicationConfigs[protocol];

      console.log(`🔍 Checking protocol: ${protocol}`);
      console.log(`  - Enabled:`, instanceConfig?.enabled);

      if (instanceConfig?.enabled && protocolConfig?.validationRules) {
        const rules = protocolConfig.validationRules;

        Object.keys(rules).forEach(field => {
          const rule = rules[field];
          const value = instanceConfig.settings?.[field];

          console.log(`  🔍 Validating field: ${field}`);
          console.log(`    - Rule:`, rule);
          console.log(`    - Value:`, value);
          console.log(`    - Is array:`, Array.isArray(value));

          // ✅ Special handling for array fields (like devices in Azure IoT Hub)
          if (rule.type === 'array') {
            console.log(`    ⚠️ ARRAY FIELD DETECTED`);

            // Check if array exists and has items
            if (rule.required && (!Array.isArray(value) || value.length === 0)) {
              errors.push({
                protocol,
                field,
                message: `${field} is required and must have at least one item`
              });
              console.log(`    ❌ Array is required but empty or missing`);
            }

            // Validate array items
            if (Array.isArray(value) && value.length > 0 && rule.items) {
              console.log(`    ✅ Validating ${value.length} array items...`);

              value.forEach((item, index) => {
                console.log(`      🔸 Item[${index}]:`, item);

                Object.keys(rule.items).forEach(itemField => {
                  const itemRule = rule.items[itemField];
                  const itemValue = item[itemField];

                  console.log(`        - Field: ${itemField}, Value: ${itemValue}, Required: ${itemRule.required}`);

                  // Required check
                  if (itemRule.required && (!itemValue || itemValue === '')) {
                    errors.push({
                      protocol,
                      field: `${field}[${index}].${itemField}`,
                      message: `${itemField} is required`
                    });
                    console.log(`        ❌ Required field missing`);
                  }

                  // Pattern check
                  if (itemRule.pattern && itemValue) {
                    const regex = new RegExp(itemRule.pattern);
                    if (!regex.test(itemValue)) {
                      errors.push({
                        protocol,
                        field: `${field}[${index}].${itemField}`,
                        message: `${itemField} does not match required pattern`
                      });
                      console.log(`        ❌ Pattern validation failed`);
                    }
                  }

                  // Min/max length
                  if (itemRule.minLength && itemValue && itemValue.length < itemRule.minLength) {
                    errors.push({
                      protocol,
                      field: `${field}[${index}].${itemField}`,
                      message: `${itemField} must be at least ${itemRule.minLength} characters`
                    });
                  }

                  if (itemRule.maxLength && itemValue && itemValue.length > itemRule.maxLength) {
                    errors.push({
                      protocol,
                      field: `${field}[${index}].${itemField}`,
                      message: `${itemField} must be at most ${itemRule.maxLength} characters`
                    });
                  }
                });
              });
            }

            return; // Skip regular validation for arrays
          }

          // Regular field validation (non-arrays)
          // if (rule.required && (!value && value !== 0 && value !== false)) {
          if (rule.required && (value === null || value === undefined || value === '')) {
            errors.push({
              protocol,
              field,
              message: `${field} is required`
            });
          }

          if (rule.pattern && value) {
            const regex = new RegExp(rule.pattern);
            if (!regex.test(String(value))) {
              errors.push({
                protocol,
                field,
                message: `${field} format is invalid`
              });
            }
          }

          if (rule.enum && value && !rule.enum.includes(value)) {
            errors.push({
              protocol,
              field,
              message: `${field} must be one of: ${rule.enum.join(', ')}`
            });
          }

          if (rule.min !== undefined && value < rule.min) {
            errors.push({
              protocol,
              field,
              message: `${field} must be at least ${rule.min}`
            });
          }

          if (rule.max !== undefined && value > rule.max) {
            errors.push({
              protocol,
              field,
              message: `${field} must be at most ${rule.max}`
            });
          }
        });
      }
    });
  }

  // Validate wireless configs
  if (component.wirelessConfigs && config.wirelessConfigs) {
    Object.keys(config.wirelessConfigs).forEach(wirelessType => {
      const wirelessConfig = component.wirelessConfigs[wirelessType];
      const instanceConfig = config.wirelessConfigs[wirelessType];

      if (instanceConfig?.enabled && wirelessConfig?.validationRules) {
        const rules = wirelessConfig.validationRules;

        Object.keys(rules).forEach(field => {
          const rule = rules[field];
          const value = instanceConfig.settings?.[field];

          // if (rule.required && (!value && value !== 0 && value !== false)) {
          if (rule.required && (value === null || value === undefined || value === '')) {
            errors.push({
              protocol: wirelessType,
              field,
              message: `${field} is required`
            });
          }

          if (rule.pattern && value) {
            const regex = new RegExp(rule.pattern);
            if (!regex.test(String(value))) {
              errors.push({
                protocol: wirelessType,
                field,
                message: `${field} format is invalid`
              });
            }
          }

          if (rule.enum && value && !rule.enum.includes(value)) {
            errors.push({
              protocol: wirelessType,
              field,
              message: `${field} must be one of: ${rule.enum.join(', ')}`
            });
          }

          if (rule.min !== undefined && value < rule.min) {
            errors.push({
              protocol: wirelessType,
              field,
              message: `${field} must be at least ${rule.min}`
            });
          }

          if (rule.max !== undefined && value > rule.max) {
            errors.push({
              protocol: wirelessType,
              field,
              message: `${field} must be at most ${rule.max}`
            });
          }
        });
      }
    });
  }

  // Validate software pins
  if (component.pinDetails && config.pinDetails) {
    component.pinDetails.forEach(pinConfig => {
      if (pinConfig.isSoftwarePin) {
        const instancePin = config.pinDetails.find(p => p.pinName === pinConfig.pinName);

        if (instancePin?.enabled && pinConfig.validationRules) {
          Object.keys(pinConfig.validationRules).forEach(field => {
            const rule = pinConfig.validationRules[field];
            const value = instancePin.settings?.[field];

            // if (rule.required && (!value && value !== 0 && value !== false)) {
            if (rule.required && (value === null || value === undefined || value === '')) {
              errors.push({
                pin: pinConfig.pinName,
                field,
                message: `${field} is required`
              });
            }

            if (rule.pattern && value) {
              const regex = new RegExp(rule.pattern);
              if (!regex.test(String(value))) {
                errors.push({
                  pin: pinConfig.pinName,
                  field,
                  message: `${field} format is invalid`
                });
              }
            }
          });
        }
      }
    });
  }

  // ============================================================================
  // AI COMPONENT CONFIGURATION VALIDATION
  // ============================================================================
  const aiCategories = ['data', 'preprocessing', 'model', 'training', 'evaluation', 'output'];
  
  if (aiCategories.includes(component.category)) {
    const configs = config.communicationConfigs || {};

    // ── data category ──────────────────────────────────────────────────────────
    if (component.category === 'data') {

      // Load CSV
      if (component.componentId === 'AI_DATA_CSV') {
        const cfg = configs.csvConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.filePath) {
            errors.push({ protocol: 'csvConfig', field: 'filePath', message: 'File path is required' });
          }
          if (!cfg.settings?.delimiter) {
            errors.push({ protocol: 'csvConfig', field: 'delimiter', message: 'Delimiter is required' });
          }
        }
      }

      // Load Images
      if (component.componentId === 'AI_DATA_IMAGES') {
        const cfg = configs.imageConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.folderPath) {
            errors.push({ protocol: 'imageConfig', field: 'folderPath', message: 'Folder path is required' });
          }
          if (!cfg.settings?.imageWidth || cfg.settings.imageWidth < 16) {
            errors.push({ protocol: 'imageConfig', field: 'imageWidth', message: 'Image width must be at least 16' });
          }
          if (!cfg.settings?.imageHeight || cfg.settings.imageHeight < 16) {
            errors.push({ protocol: 'imageConfig', field: 'imageHeight', message: 'Image height must be at least 16' });
          }
          if (!cfg.settings?.batchSize || cfg.settings.batchSize < 1) {
            errors.push({ protocol: 'imageConfig', field: 'batchSize', message: 'Batch size must be at least 1' });
          }
        }
      }

      // Fetch API
      if (component.componentId === 'AI_DATA_API') {
        const cfg = configs.apiConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.url) {
            errors.push({ protocol: 'apiConfig', field: 'url', message: 'API URL is required' });
          } else {
            const urlPattern = /^https?:\/\/[^\s/$.?#].[^\s]*$/;
            if (!urlPattern.test(cfg.settings.url)) {
              errors.push({ protocol: 'apiConfig', field: 'url', message: 'API URL format is invalid' });
            }
          }
          if (!cfg.settings?.method) {
            errors.push({ protocol: 'apiConfig', field: 'method', message: 'HTTP method is required' });
          }
        }
      }
    }

    // ── preprocessing category ─────────────────────────────────────────────────
    if (component.category === 'preprocessing') {

      // Normalize
      if (component.componentId === 'AI_PRE_NORMALIZE') {
        const cfg = configs.normalizeConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.method) {
            errors.push({ protocol: 'normalizeConfig', field: 'method', message: 'Normalization method is required' });
          }
          if (cfg.settings?.method === 'minmax') {
            if (cfg.settings.featureRangeMin >= cfg.settings.featureRangeMax) {
              errors.push({ protocol: 'normalizeConfig', field: 'featureRangeMin', message: 'Feature range min must be less than max' });
            }
          }
        }
      }

      // Train/Test Split
      if (component.componentId === 'AI_PRE_SPLIT') {
        const cfg = configs.splitConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.testSize) {
            errors.push({ protocol: 'splitConfig', field: 'testSize', message: 'Test size is required' });
          } else if (cfg.settings.testSize < 0.1 || cfg.settings.testSize > 0.5) {
            errors.push({ protocol: 'splitConfig', field: 'testSize', message: 'Test size must be between 0.1 and 0.5' });
          }
        }
      }

      // Encode Labels
      if (component.componentId === 'AI_PRE_ENCODE') {
        const cfg = configs.encodeConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.encodingType) {
            errors.push({ protocol: 'encodeConfig', field: 'encodingType', message: 'Encoding type is required' });
          }
          if (!cfg.settings?.targetColumn) {
            errors.push({ protocol: 'encodeConfig', field: 'targetColumn', message: 'Target column name is required' });
          }
        }
      }
    }

    // ── model category ─────────────────────────────────────────────────────────
    if (component.category === 'model') {

      // PyTorch CNN
      if (component.componentId === 'AI_MODEL_CNN') {
        const cfg = configs.cnnConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.numClasses || cfg.settings.numClasses < 2) {
            errors.push({ protocol: 'cnnConfig', field: 'numClasses', message: 'Number of classes must be at least 2' });
          }
          if (!cfg.settings?.learningRate || cfg.settings.learningRate <= 0) {
            errors.push({ protocol: 'cnnConfig', field: 'learningRate', message: 'Learning rate must be greater than 0' });
          }
          if (cfg.settings?.dropout < 0 || cfg.settings?.dropout >= 1) {
            errors.push({ protocol: 'cnnConfig', field: 'dropout', message: 'Dropout must be between 0.0 and 0.9' });
          }
        }
      }

      // Sklearn Classifier
      if (component.componentId === 'AI_MODEL_SKLEARN') {
        const cfg = configs.classifierConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.classifierType) {
            errors.push({ protocol: 'classifierConfig', field: 'classifierType', message: 'Classifier type is required' });
          }
          if (cfg.settings?.classifierType === 'knn' && cfg.settings?.knnNeighbors < 1) {
            errors.push({ protocol: 'classifierConfig', field: 'knnNeighbors', message: 'KNN neighbors must be at least 1' });
          }
          if (cfg.settings?.classifierType === 'svm' && cfg.settings?.svmC <= 0) {
            errors.push({ protocol: 'classifierConfig', field: 'svmC', message: 'SVM C parameter must be greater than 0' });
          }
        }
      }

      // Linear Regression
      if (component.componentId === 'AI_MODEL_LINREG') {
        const cfg = configs.regressionConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.regressionType) {
            errors.push({ protocol: 'regressionConfig', field: 'regressionType', message: 'Regression type is required' });
          }
          if (!cfg.settings?.targetColumn) {
            errors.push({ protocol: 'regressionConfig', field: 'targetColumn', message: 'Target column name is required' });
          }
          if (['ridge', 'lasso', 'elasticnet'].includes(cfg.settings?.regressionType) && cfg.settings?.alpha <= 0) {
            errors.push({ protocol: 'regressionConfig', field: 'alpha', message: 'Alpha must be greater than 0' });
          }
        }
      }

      // LSTM
      if (component.componentId === 'AI_MODEL_LSTM') {
        const cfg = configs.lstmConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.inputSize || cfg.settings.inputSize < 1) {
            errors.push({ protocol: 'lstmConfig', field: 'inputSize', message: 'Input size must be at least 1' });
          }
          if (!cfg.settings?.hiddenSize || cfg.settings.hiddenSize < 8) {
            errors.push({ protocol: 'lstmConfig', field: 'hiddenSize', message: 'Hidden size must be at least 8' });
          }
          if (!cfg.settings?.outputSize || cfg.settings.outputSize < 1) {
            errors.push({ protocol: 'lstmConfig', field: 'outputSize', message: 'Output size must be at least 1' });
          }
          if (!cfg.settings?.learningRate || cfg.settings.learningRate <= 0) {
            errors.push({ protocol: 'lstmConfig', field: 'learningRate', message: 'Learning rate must be greater than 0' });
          }
        }
      }
    }

    // ── training category ──────────────────────────────────────────────────────
    if (component.category === 'training') {

      // Train Loop
      if (component.componentId === 'AI_TRAIN_LOOP') {
        const cfg = configs.trainConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.epochs || cfg.settings.epochs < 1) {
            errors.push({ protocol: 'trainConfig', field: 'epochs', message: 'Epochs must be at least 1' });
          }
          if (!cfg.settings?.batchSize || cfg.settings.batchSize < 1) {
            errors.push({ protocol: 'trainConfig', field: 'batchSize', message: 'Batch size must be at least 1' });
          }
          if (cfg.settings?.saveCheckpoints && !cfg.settings?.checkpointPath) {
            errors.push({ protocol: 'trainConfig', field: 'checkpointPath', message: 'Checkpoint path is required when saving checkpoints' });
          }
        }
      }

      // Optimizer
      if (component.componentId === 'AI_TRAIN_OPTIMIZER') {
        const cfg = configs.optimizerConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.type) {
            errors.push({ protocol: 'optimizerConfig', field: 'type', message: 'Optimizer type is required' });
          }
          if (!cfg.settings?.learningRate || cfg.settings.learningRate <= 0) {
            errors.push({ protocol: 'optimizerConfig', field: 'learningRate', message: 'Learning rate must be greater than 0' });
          }
          if (cfg.settings?.learningRate > 0.1) {
            warnings.push({ protocol: 'optimizerConfig', field: 'learningRate', message: 'Learning rate above 0.1 may cause unstable training' });
          }
        }
      }

      // Loss Function
      if (component.componentId === 'AI_TRAIN_LOSS') {
        const cfg = configs.lossConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.type) {
            errors.push({ protocol: 'lossConfig', field: 'type', message: 'Loss function type is required' });
          }
          if (!cfg.settings?.reduction) {
            errors.push({ protocol: 'lossConfig', field: 'reduction', message: 'Reduction method is required' });
          }
          if (cfg.settings?.type === 'bce' && cfg.settings?.posWeight <= 0) {
            errors.push({ protocol: 'lossConfig', field: 'posWeight', message: 'Positive weight must be greater than 0' });
          }
        }
      }
    }

    // ── evaluation category ────────────────────────────────────────────────────
    if (component.category === 'evaluation') {

      // Accuracy Score
      if (component.componentId === 'AI_EVAL_ACCURACY') {
        const cfg = configs.accuracyConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.average) {
            errors.push({ protocol: 'accuracyConfig', field: 'average', message: 'Averaging method is required' });
          }
          if (!cfg.settings?.topK || cfg.settings.topK < 1) {
            errors.push({ protocol: 'accuracyConfig', field: 'topK', message: 'Top-K must be at least 1' });
          }
        }
      }

      // Plot Loss Curve
      if (component.componentId === 'AI_EVAL_LOSS_CURVE') {
        const cfg = configs.plotConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.title) {
            errors.push({ protocol: 'plotConfig', field: 'title', message: 'Plot title is required' });
          }
          if (!cfg.settings?.xlabel) {
            errors.push({ protocol: 'plotConfig', field: 'xlabel', message: 'X axis label is required' });
          }
          if (!cfg.settings?.ylabel) {
            errors.push({ protocol: 'plotConfig', field: 'ylabel', message: 'Y axis label is required' });
          }
        }
      }

      // Confusion Matrix
      if (component.componentId === 'AI_EVAL_CONFUSION') {
        const cfg = configs.confusionConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.title) {
            errors.push({ protocol: 'confusionConfig', field: 'title', message: 'Plot title is required' });
          }
          if (cfg.settings?.savePath && !cfg.settings.savePath.match(/\.(png|pdf|jpg)$/)) {
            warnings.push({ protocol: 'confusionConfig', field: 'savePath', message: 'Save path should end with .png, .pdf or .jpg' });
          }
        }
      }
    }

    // ── output category ────────────────────────────────────────────────────────
    if (component.category === 'output') {

      // Save Model
      if (component.componentId === 'AI_OUT_SAVE_MODEL') {
        const cfg = configs.saveConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.savePath) {
            errors.push({ protocol: 'saveConfig', field: 'savePath', message: 'Save path is required' });
          }
          if (!cfg.settings?.format) {
            errors.push({ protocol: 'saveConfig', field: 'format', message: 'Save format is required' });
          }
          if (cfg.settings?.format === 'onnx' && !cfg.settings?.exportOnnxInputShape) {
            errors.push({ protocol: 'saveConfig', field: 'exportOnnxInputShape', message: 'ONNX export requires input shape (e.g. 1,3,224,224)' });
          }
        }
      }

      // Print Results
      if (component.componentId === 'AI_OUT_PRINT_RESULTS') {
        const cfg = configs.printConfig;
        if (cfg?.enabled) {
          if (!cfg.settings?.title) {
            errors.push({ protocol: 'printConfig', field: 'title', message: 'Report title is required' });
          }
          if (cfg.settings?.exportToFile && !cfg.settings?.exportPath) {
            errors.push({ protocol: 'printConfig', field: 'exportPath', message: 'Export path is required when exporting to file' });
          }
        }
      }
    }
  }

  // ============================================================================
  // AGENTIC AI COMPONENT CONFIGURATION VALIDATION
  // ============================================================================
  const agCategories = [
    'foundation', 'chain', 'rag',
    'graph', 'graph_nodes', 'graph_edges',
    'tools', 'memory', 'output'
  ];

  if (agCategories.includes(component.category)) {
    const configs = config.communicationConfigs || {};

    const agReqs = {
      'AG_FOUND_LLM':        { key: 'llmConfig',           fields: ['model', 'temperature'] },
      'AG_FOUND_EMBED':      { key: 'embeddingConfig',      fields: ['model'] },
      'AG_FOUND_PROMPT':     { key: 'promptConfig',         fields: ['systemPrompt', 'humanTemplate'] },
      'AG_FOUND_PARSER':     { key: 'parserConfig',         fields: ['parserType'] },
      'AG_FOUND_APIKEY':     { key: 'apiKeyConfig',         fields: ['provider', 'envVarName'] },
      'AG_RAG_CHUNKER':      { key: 'chunkerConfig',        fields: ['chunkSize', 'chunkOverlap'] },
      'AG_RAG_PINECONE':     { key: 'pineconeConfig',       fields: ['indexName', 'namespace', 'dimensions'] },
      'AG_RAG_RETRIEVER':    { key: 'retrieverConfig',      fields: ['topK', 'searchType'] },
      'AG_GRAPH_STATE':      { key: 'stateConfig',          fields: ['fields'] },
      'AG_GRAPH_SUPERVISOR': { key: 'supervisorConfig',     fields: ['systemPrompt', 'nextOptions'] },
      'AG_GRAPH_GUARD':      { key: 'guardConfig',          fields: ['faithfulnessThreshold'] },
      'AG_GRAPH_EDGE':       { key: 'edgeConfig',           fields: ['fromNode', 'toNode'] },
      'AG_GRAPH_COND_EDGE':  { key: 'condEdgeConfig',       fields: ['routerLogic', 'branches'] },
      'AG_GRAPH_BUILDER':    { key: 'builderConfig',        fields: ['entryPoint'] },
      'AG_GRAPH_RUNNER':     { key: 'runnerConfig',         fields: ['inputMessage'] },
      'AG_MEM_CHECKPOINT':   { key: 'checkpointConfig',     fields: ['dbName', 'collectionName'] },
      'AG_MEM_REDIS':        { key: 'redisConfig',          fields: ['redisUrl', 'ttlSeconds'] },
      'AG_TOOL_SEARCH':      { key: 'searchToolConfig',     fields: ['indexName', 'topK'] },
      'AG_TOOL_GRADE':       { key: 'gradeToolConfig',      fields: ['rubric'] },
      'AG_TOOL_QUIZ':        { key: 'quizToolConfig',       fields: ['topic', 'n'] },
      'AG_OUT_RUNNER':       { key: 'outRunnerConfig',      fields: ['inputMessage'] },
    };

    const req = agReqs[component.componentId];
    if (req) {
      const cfg = configs[req.key];
      if (!cfg || cfg.enabled === false) {
        warnings.push({
          protocol: req.key,
          field:    'enabled',
          message:  `Configuration is not enabled. Open the component configuration panel.`
        });
      } else {
        req.fields.forEach(field => {
          const val = cfg.settings?.[field];
          if (val === undefined || val === null || val === '' ||
              (Array.isArray(val) && val.length === 0) ||
              (typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length === 0)) {
            errors.push({
              protocol: req.key,
              field,
              message: `${field} is required`
            });
          }
        });
      }
    }
  }

  console.log('✅ Frontend validation complete');
  console.log('  - Errors:', errors.length);
  console.log('  - Warnings:', warnings.length);

  return {
    valid: errors.length === 0,
    errors,
    warnings
  };
}




